import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { safeParseJSON } from '../../../../utils/jsonValidator';

export const MenuCompanyOption = ({ configuration, onChange, t, inline = false }) => {
    const config = safeParseJSON(configuration);
    const [selectCompany, setSelectCompany] = useState(config?.select_company ?? false);

    useEffect(() => {
        setSelectCompany(config?.select_company ?? false);
    }, [configuration]);

    const handleChange = (checked) => {
        setSelectCompany(checked);
        onChange('configuration', {
            ...config,
            select_company: checked,
        });
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', px: inline ? 0 : 1 }}>
            <FormControlLabel
                control={
                    <Switch
                        size="small"
                        checked={selectCompany}
                        onChange={(e) => handleChange(e.target.checked)}
                    />
                }
                label={
                    <Typography variant="body2">
                        {t('common.companySelect')}
                    </Typography>
                }
            />
        </Box>
    );
};
